module.exports = __webpack_public_path__ + "img/theme-flat.c4fa46a2.png";